<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 16px;
    background: #F58020;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s;

    &:hover { opacity: 0.9; color: #fff; }
  }
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;

  .search-box {
    position: relative;
    flex: 1;
    min-width: 180px;
    max-width: 280px;

    i {
      position: absolute;
      left: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #a0aab8;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 36px;
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      padding: 0 12px 0 32px;
      font-size: 13px;
      color: #0d1b3e;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder { color: #b0bac9; }
      &:focus { border-color: #389ad4; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
    }
  }

  .filter-select {
    height: 36px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 28px 0 10px;
    font-size: 13px;
    color: #0d1b3e;
    background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
    appearance: none;
    outline: none;
    cursor: pointer;
    transition: border-color 0.2s;

    &:focus { border-color: #389ad4; }
  }

  /* ── Type-and-select ── */
  .ts-wrap {
    position: relative;
    min-width: 200px;
    max-width: 260px;
  }

  .ts-input {
    display: flex;
    align-items: center;
    height: 36px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 10px;
    background: #fff;
    cursor: pointer;
    gap: 6px;
    transition: border-color 0.2s;

    &:hover { border-color: #389ad4; }
    &:focus-within { border-color: #389ad4; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  }

  .ts-val {
    flex: 1;
    font-size: 13px;
    color: #0d1b3e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
  }

  .ts-search {
    flex: 1;
    border: none;
    outline: none;
    font-size: 13px;
    color: #0d1b3e;
    font-family: 'Segoe UI', sans-serif;
    background: transparent;
    min-width: 0;

    &::placeholder { color: #b0bac9; }
  }

  .ts-arrow {
    font-size: 10px;
    color: #a0aab8;
    flex-shrink: 0;
    transition: transform 0.2s;
    pointer-events: none;

    &.open { transform: rotate(180deg); }
  }

  .btn-search {
    height: 36px;
    padding: 0 16px;
    background: #389ad4;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: opacity 0.2s;

    &:hover { opacity: 0.9; }
  }
}

/* ── Type-and-select dropdown ── */
.ts-dropdown {
  position: fixed;
  background: #fff;
  border: 1.5px solid #dde2ec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  z-index: 9999;
  max-height: 220px;
  overflow-y: auto;
}

.ts-item {
  padding: 8px 12px;
  font-size: 13px;
  color: #0d1b3e;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  transition: background 0.12s;

  &:hover { background: #f0f7fd; color: #389ad4; }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}

/* ── Table ── */
.loc-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
  table-layout: fixed;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 10px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover { background: #f8fbff; }

    td {
      padding: 10px 10px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

/* ── Location avatar ── */
.loc-avatar {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #f0f4fa;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0bac9;
  font-size: 17px;
}

.loc-name  { font-weight: 600; color: #0d1b3e; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.loc-addr  { font-size: 12px; color: #7a8499; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.loc-slug  {
  font-size: 11px;
  margin-top: 3px;
  color: #389ad4;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;

  &:hover { text-decoration: underline; }
}

.loc-tz {
  font-size: 12px;
  color: #4a5568;
  word-break: break-word;
}

/* ── Badges ── */
.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  &.active   { background: #c6f6d5; color: #276749; }
  &.inactive { background: #fed7d7; color: #c53030; }
  &.online   { background: #c6f6d5; color: #276749; }
  &.offline  { background: #fed7d7; color: #c53030; }
  &.qb-yes   { background: #c6f6d5; color: #276749; }
  &.qb-no    { background: #e2e8f0; color: #718096; }
  &.contract-active  { background: #c6f6d5; color: #276749; }
  &.contract-expired { background: #fed7d7; color: #c53030; }
  &.contract-none    { background: #e2e8f0; color: #a0aab8; }
}

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover { background: #eef2fb; color: #185FA5; border-color: #c5d4f0; }
  }

  .action-menu {
    display: none;
    position: fixed;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 150px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 9999;
    overflow: hidden;

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      transition: background 0.15s;

      i { width: 16px; font-size: 13px; }

      &:hover { background: #f8fbff; }

      &.blue    { color: #185FA5;  i { color: #185FA5; }  &:hover { background: #eef2fb; color: #1E6FB8; i { color: #1E6FB8; } } }
      &.teal    { color: #276749;  i { color: #276749; }  &:hover { background: #f0fdf4; color: #1d5230; i { color: #1d5230; } } }
      &.orange  { color: #c05621;  i { color: #c05621; }  &:hover { background: #fff7ed; color: #9c4318; i { color: #9c4318; } } }
      &.purple  { color: #6b46c1;  i { color: #6b46c1; }  &:hover { background: #f5f3ff; color: #553c9a; i { color: #553c9a; } } }
      &.danger  { color: #c62828;  i { color: #c62828; }  &:hover { background: #fff5f5; color: #9b1c1c; i { color: #9b1c1c; } } }

      &.divider { border-top: 1px solid #f0f3fa; pointer-events: none; padding: 0; margin: 0; }
    }
  }

  &.open .action-menu { display: block; }
}

/* ── Empty / loading ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i { font-size: 30px; display: block; margin-bottom: 10px; opacity: 0.45; }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;

  .pg-info { font-size: 12px; color: #7a8499; white-space: nowrap; }

  .pg-controls { display: flex; align-items: center; gap: 4px; }

  .pg-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border: 1.5px solid #dde2ec;
    background: #fff;
    color: #4a5568;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;

    &:hover:not(:disabled) { border-color: #389ad4; color: #389ad4; }
    &:disabled { opacity: 0.35; cursor: default; }
    &.active { background: #389ad4; border-color: #389ad4; color: #fff; }
  }

  .pg-size select {
    height: 32px;
    border: 1.5px solid #dde2ec;
    border-radius: 6px;
    padding: 0 8px;
    font-size: 12px;
    color: #4a5568;
    background: #fff;
    cursor: pointer;
    outline: none;

    &:focus { border-color: #389ad4; }
  }
}

/* ── Delete confirm modal ── */
.del-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9100;
  backdrop-filter: blur(3px);
  padding: 20px;
  font-family: 'Segoe UI', sans-serif;
}

.del-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(13, 27, 62, 0.22);
  width: 100%;
  max-width: 380px;
  overflow: hidden;
}

.del-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 24px 16px;
  background: #fff5f5;
  border-bottom: 1px solid #fed7d7;
}

.del-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #fed7d7;
  color: #c62828;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-bottom: 12px;
}

.del-title {
  font-size: 15px;
  font-weight: 700;
  color: #c62828;
}

.del-body {
  padding: 20px 24px 8px;
  text-align: center;
}

.del-msg {
  font-size: 13px;
  color: #4a5568;
  line-height: 1.6;
  margin: 0 0 6px;

  strong { color: #0d1b3e; }
}

.del-warn {
  font-size: 11px;
  color: #e53e3e;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 8px;
}

.del-foot {
  display: flex;
  gap: 10px;
  padding: 16px 24px 24px;

  button {
    flex: 1;
    height: 40px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: 'Segoe UI', sans-serif;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;
  }

  .btn-del-cancel {
    background: #fff;
    color: #4a5568;
    border: 1.5px solid #dde2ec;

    &:hover { border-color: #389ad4; color: #389ad4; }
  }

  .btn-del-confirm {
    background: #c62828;
    color: #fff;
    border: none;

    &:hover { background: #9b1c1c; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
}
</style>

<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-map-marker-alt"></i>
          Locations
          <span style="font-size:12px; color:#7a8499; font-weight:400;" v-if="filteredLocations.length">
            ({{ filteredLocations.length }})
          </span>
        </span>
        <router-link
          v-if="currentUser.u.roles == 'admin'"
          :to="{ name: 'client.location.create' }"
          class="btn-add"
        >
          <i class="fa fa-plus"></i> Add Location
        </router-link>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">
        <div class="ts-wrap" v-if="currentUser.u.is_admin" ref="spWrap" v-click-outside="closeSpDropdown">
          <div class="ts-input" @click="toggleSp">
            <span class="ts-val" v-if="!spOpen">{{ spLabel }}</span>
            <input v-if="spOpen" type="text" class="ts-search" v-model="spSearch"
              placeholder="Search provider…" ref="spInput" @keydown.esc="closeSpDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: spOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="spOpen" :style="spDropStyle">
            <div class="ts-item" @click="selectSp('all')">All Service Providers</div>
            <div class="ts-item" v-for="(p, i) in filteredSp" :key="i" @click="selectSp(p.id)">{{ p.name }}</div>
            <div class="ts-empty" v-if="filteredSp.length === 0 && spSearch">No match</div>
          </div>
        </div>

        <div class="search-box">
          <i class="fa fa-search"></i>
          <input type="text" placeholder="Search by name…" v-model="searchInput" />
        </div>

        <select class="filter-select" v-model="status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="all">All Status</option>
        </select>

        <select class="filter-select" v-model="offline_mode">
          <option value="online">Online</option>
          <option value="offline">Offline</option>
          <option value="all">All Modes</option>
        </select>

        <select class="filter-select" v-model="contract_status">
          <option value="all">All Contracts</option>
          <option value="active">Contract Active</option>
          <option value="expired">Contract Expired</option>
          <option value="none">No Contract</option>
        </select>

        <button class="btn-search" @click="search()">
          <i class="fa fa-search"></i> Search
        </button>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="loadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading locations…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="filteredLocations.length === 0">
        <i class="fa fa-map-marker-alt"></i>
        No locations found
      </div>

      <!-- Table -->
      <div v-else>
        <table class="loc-table">
          <thead>
            <tr>
              <th style="width:32px;">#</th>
              <th style="width:50px;"></th>
              <th style="width:180px;">Name / Address</th>
              <th style="width:120px;">Time Zone</th>
              <th style="width:80px; text-align:right;">Status</th>
              <th style="width:78px; text-align:right;">Mode</th>
              <th style="width:90px; text-align:right;">Contract</th>
              <th v-if="!currentUser.u.is_admin" style="width:90px; text-align:right;">QuickBooks</th>
              <th v-if="currentUser.u.roles == 'admin'" style="width:54px; text-align:right;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pagedList" :key="item.id || index">
              <td style="color:#a0aab8; font-size:12px;">{{ (currentPage - 1) * perPage + index + 1 }}</td>
              <td>
                <div
                  class="loc-avatar"
                  :style="item.image ? { backgroundImage: 'url(' + getBLocations.url + item.image + ')', backgroundColor: 'transparent' } : {}"
                >
                  <i v-if="!item.image" class="fa fa-map-marker-alt"></i>
                </div>
              </td>
              <td>
                <div class="loc-name">{{ item.name }}</div>
                <div class="loc-addr">{{ item.full_address }}</div>
                <a
                  class="loc-slug"
                  :href="getBLocations.f_url + '/client/login?s=' + item.slug"
                  target="_blank"
                >
                  <i class="fa fa-link" style="font-size:10px;"></i> {{ item.slug }}
                </a>
              </td>
              <td class="loc-tz">{{ item.client_timezone || '—' }}</td>
              <td style="text-align:right;">
                <span :class="['badge-pill', item.is_active ? 'active' : 'inactive']">
                  <i :class="item.is_active ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                  {{ item.is_active ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td style="text-align:right;">
                <span :class="['badge-pill', item.is_offline_mode ? 'offline' : 'online']">
                  <i :class="item.is_offline_mode ? 'fa fa-wifi' : 'fa fa-wifi'"></i>
                  {{ item.is_offline_mode ? 'Offline' : 'Online' }}
                </span>
              </td>
              <td style="text-align:right;">
                <span v-if="item.contract_status === 'active'" class="badge-pill contract-active">
                  <i class="fa fa-check-circle"></i> Active
                </span>
                <span v-else-if="item.contract_status === 'expired'" class="badge-pill contract-expired">
                  <i class="fa fa-times-circle"></i> Expired
                </span>
                <span v-else class="badge-pill contract-none">—</span>
              </td>
              <td v-if="!currentUser.u.is_admin" style="text-align:right;">
                <span :class="['badge-pill', item.is_quickbooks_synced ? 'qb-yes' : 'qb-no']">
                  <i :class="item.is_quickbooks_synced ? 'fa fa-check' : 'fa fa-times'"></i>
                  {{ item.is_quickbooks_synced ? 'Synced' : 'Not Synced' }}
                </span>
              </td>
              <td v-if="currentUser.u.roles == 'admin'" style="text-align:right; overflow:visible;" @click.stop>
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)" :ref="`dropdown-${index}`">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :style="openIndex === index ? menuStyle : null">
                    <div class="menu-item blue" @click.stop="editItem(item.id)">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </div>
                    <div class="menu-item teal" @click.stop="openLocationUsers(item.id)">
                      <i class="fa fa-users"></i> Users
                    </div>
                    <div class="menu-item orange" @click.stop="editRate(item.id)">
                      <i class="fa fa-dollar-sign"></i> Rate
                    </div>
                    <div v-if="currentUser.u.is_admin" class="menu-item orange" @click.stop="editSupportContract(item.id)">
                      <i class="fa fa-file-contract"></i> Support Contract
                    </div>
                    <div v-if="!currentUser.u.is_admin" class="menu-item purple" @click.stop="syncQuickBook(item.id)">
                      <i class="fa fa-sync"></i> {{ item.is_quickbooks_synced ? 'Resync QB' : 'Sync QB' }}
                    </div>
                    <div class="menu-item purple" @click.stop="openbaseplan(item.id, item.name)">
                      <i class="fa fa-layer-group"></i> Base Plan
                    </div>
                    <div class="menu-item divider"></div>
                    <div class="menu-item danger" @click.stop="deleteItem(item.id, (currentPage - 1) * perPage + index)">
                      <i class="fa fa-trash"></i> Delete
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="filteredLocations.length > perPage">
        <span class="pg-info">
          Showing {{ (currentPage - 1) * perPage + 1 }}–{{ Math.min(currentPage * perPage, filteredLocations.length) }}
          of {{ filteredLocations.length }}
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage = 1">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage--">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === currentPage }"
            @click="currentPage = p">{{ p }}</button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage++">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage = totalPages">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
        <div class="pg-size">
          <select v-model="perPage" @change="currentPage = 1">
            <option :value="10">10 / page</option>
            <option :value="25">25 / page</option>
            <option :value="50">50 / page</option>
          </select>
        </div>
      </div>

    </div>

    <!-- Delete Confirmation Modal -->
    <div class="del-overlay" v-if="delModal.show" @click.self="delModal.show = false">
      <div class="del-card">
        <div class="del-head">
          <div class="del-icon"><i class="fa fa-trash-alt"></i></div>
          <div class="del-title">Delete Location</div>
        </div>
        <div class="del-body">
          <p class="del-msg">
            You are about to permanently delete<br />
            <strong>{{ delModal.name }}</strong>
          </p>
          <div class="del-warn">
            <i class="fa fa-exclamation-circle"></i>
            This action cannot be undone
          </div>
        </div>
        <div class="del-foot">
          <button class="btn-del-cancel" @click="delModal.show = false">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button class="btn-del-confirm" @click="confirmDelete()">
            <i class="fa fa-trash"></i> Delete
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_B_LOCATIONS,
  DELETE_B_LOCATION,
  SYNC_QUICKBOOK_CUSTOMERS,
  GET_SERVICE_PROVIDER_LIST,
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  data() {
    return {
      status: "active",
      offline_mode: "online",
      contract_status: "all",
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Locations", route: "" }
      ],
      loadingData: false,
      searchInput: "",
      syncingId: null,
      service_provider: "all",
      spOpen: false, spSearch: "", spDropStyle: {},
      currentPage: 1,
      perPage: 10,
      openIndex: null,
      menuStyle: null,
      delModal: {
        show: false,
        id: null,
        index: null,
        name: ""
      },
    };
  },
  mounted() {
    this.status = "active";
    this.offline_mode = "online";
  },
  computed: {
    ...mapGetters(["getBLocations", "currentUser", "getserviceProviders"]),
    filteredSp() {
      const q = (this.spSearch || "").toLowerCase();
      const list = this.getserviceProviders || [];
      return q ? list.filter(p => p.name && p.name.toLowerCase().includes(q)) : list;
    },
    spLabel() {
      if (this.service_provider === "all") return "All Service Providers";
      const p = (this.getserviceProviders || []).find(p => p.id === this.service_provider);
      return p ? p.name : "All Service Providers";
    },
    filteredLocations() {
      let list = this.getBLocations.data || [];
      if (this.searchInput) {
        list = list.filter(item =>
          item.name.toUpperCase().includes(this.searchInput.toUpperCase())
        );
      }
      return list;
    },
    totalPages() {
      return Math.ceil(this.filteredLocations.length / this.perPage) || 1;
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredLocations.slice(start, start + this.perPage);
    },
    visiblePages() {
      const pages = [];
      for (let i = Math.max(1, this.currentPage - 2); i <= Math.min(this.totalPages, this.currentPage + 2); i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  watch: {
    filteredLocations() {
      this.currentPage = 1;
    }
  },
  created() {
    if (this.currentUser.u.is_admin) {
      this.getServiceProvider();
    }
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getLocationData();
    document.addEventListener("click", this.closeDropdown);
    window.addEventListener("scroll", this.closeDropdown, true);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener("scroll", this.closeDropdown, true);
  },
  methods: {
    toggleSp() {
      this.spOpen = !this.spOpen;
      if (this.spOpen) {
        this.spSearch = "";
        this.$nextTick(() => {
          if (this.$refs.spInput) this.$refs.spInput.focus();
          const wrap = this.$refs.spWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.spDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeSpDropdown() { this.spOpen = false; this.spSearch = ""; this.spDropStyle = {}; },
    selectSp(id) {
      this.service_provider = id;
      this.closeSpDropdown();
      this.getLocationData();
    },
    syncQuickBook(id) {
      if (this.syncingId) return;
      this.closeDropdown();
      this.syncingId = id;
      this.$store.dispatch(SYNC_QUICKBOOK_CUSTOMERS, id)
        .then(() => {
          this.syncingId = null;
          this.$toastr.s("Synced Successfully");
          this.getLocationData();
        })
        .catch(e => {
          this.syncingId = null;
          this.$toastr.e((e && e.msg) || "Failed to sync with QuickBooks");
        });
    },
    search() {
      this.getLocationData();
    },
    deleteItem(id, index) {
      const item = (this.getBLocations.data || []).find(l => l.id === id);
      this.delModal = { show: true, id, index, name: item ? item.name : "" };
    },
    confirmDelete() {
      this.$store.dispatch(DELETE_B_LOCATION, this.delModal.id).then(data => {
        this.$toastr.s(data.msg);
        this.getBLocations.data.splice(this.delModal.index, 1);
        this.delModal.show = false;
      });
    },
    editRate(id) {
      this.$router.push({ name: "client.location.rate", params: { id } });
    },
    editSupportContract(id) {
      this.$router.push({ name: "client.location.supportcontract", params: { id } });
    },
    openLocationUsers(id) {
      this.$router.push({ name: "client.location.users", params: { id } });
    },
    editItem(id) {
      this.$router.push({ name: "client.location.edit", params: { id } });
    },
    openbaseplan(id, name) {
      const client_slug = this.$route.params.client_slug;
      const client = this.currentUser.u.is_client ? "c" : "sp";
      this.$router.push({
        name: "client.baseplan.location",
        params: { location_id: id, client_slug, client, location: name }
      });
    },
    getLocationData() {
      this.loadingData = true;
      this.$store
        .dispatch(FETCH_B_LOCATIONS, {
          status: this.status,
          offline_mode: this.offline_mode,
          service_provider: this.service_provider,
          contract_status: this.contract_status
        })
        .then(() => { this.loadingData = false; })
        .catch(() => { this.loadingData = false; });
    },
    getServiceProvider() {
      this.loadingData = true;
      this.$store
        .dispatch(GET_SERVICE_PROVIDER_LIST)
        .then(res => {
          if (res.code == 200) this.url = res.url;
          this.loadingData = false;
        })
        .catch(err => {
          this.loadingData = false;
          this.msg = err.error;
        });
    },
    toggleDropdown(index, event) {
      if (this.openIndex === index) {
        this.openIndex = null;
        this.menuStyle = null;
        return;
      }
      this.openIndex = index;
      this.$nextTick(() => {
        const rect = event.currentTarget.getBoundingClientRect();
        const menuH = 160;
        const rightOffset = window.innerWidth - rect.right;
        if (window.innerHeight - rect.bottom < menuH + 8) {
          this.menuStyle = { position: 'fixed', bottom: (window.innerHeight - rect.top + 4) + 'px', top: 'auto', right: rightOffset + 'px' };
        } else {
          this.menuStyle = { position: 'fixed', top: (rect.bottom + 4) + 'px', bottom: 'auto', right: rightOffset + 'px' };
        }
      });
    },
    closeDropdown() {
      this.openIndex = null;
      this.menuStyle = null;
    }
  }
};
</script>
